import type { FunctionTestWidgetConfig } from '../function-test.model';

export const FUNCTION_TEST_HLT_QUADRATIC_PRESET: FunctionTestWidgetConfig = {
  id: 'function-test-hlt-quadratic',
  type: 'function-test',
  params: {
    mode: 'hlt',
    curve: {
      type: 'expression',
      expression: 'x * x',
    },
  },
  display: {},
};
